module.exports = __webpack_public_path__ + "img/rg-bottom.b5969802.png";